<!--公用组件：avatar头像组件
    @dengli
    @date 2018年10月29日
    props
        - username {String}  - 用户名称，不传则默认不显示头像下方用户名
        - color {String}  - 无头像时，文字头像和背景图的颜色风格
        - textAvatar {String}  - 文字头像
        - avatarUrl {String}  - 用户头像
        - avatarBorder {Boolean}  - 用户头像白色边框，默认不显示
    调用示例
        <avatar :username="username" :avatarUrl="avatarUrl" :avatarBorder="true"/>
    ps: 
        - 如需修改头像及内部文字大小，直接覆盖样式即可
-->
<template>
    <div class="avatar-info" @click="handleEgg">
        <img :src="avatarUrl" style="display: none;" class="lazyload" />
        <div v-if="!avatar" class="text-avatar" :class="[color, { 'avatar-border': avatarBorder }]">
            {{ textAvatar }}
        </div>
        <img v-else :src="avatarUrl" class="avatar" :class="{ 'avatar-border': avatarBorder, egg: egg }" />
        <div class="username" :class="{ 'name-egg': nameEgg }" v-show="username">{{ $root.remark.getRemarkName(userId, username, $root.remark.remarkVerison, 'all') }}</div>
    </div>
</template>

<style lang="scss" scoped>
.avatar-info {
    font-size: 1.9rem;
    z-index: 1;
    .avatar,
    .text-avatar {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 1.95rem;
    }
    .avatar.egg {
        transform: rotate(5turn);
        transition-duration: 1s;
        transition-timing-function: cubic-bezier(0.8, -0.5, 0.2, 1);
    }
    .text-avatar.egg {
        transform: rotate(5turn);
        transition-duration: 1s;
        transition-timing-function: cubic-bezier(0.8, -0.5, 0.2, 1);
    }
    .avatar.avatar-border {
        // border: .2rem solid white;
        box-shadow: white 0 0 0 0.2rem;
    }
    .text-avatar.avatar-border {
        // border: .2rem solid white;
        box-shadow: white 0 0 0 0.2rem;
    }
    .text-avatar.red {
        background-color: #ff6a83;
    }
    .text-avatar.blue {
        background-color: #69a7ec;
    }
    .text-avatar.green {
        background-color: #57d092;
    }
    .text-avatar.purple {
        background-color: #8765ca;
    }
    .text-avatar.cyan {
        background-color: #00ccd6;
    }
    .text-avatar.orange {
        background-color: #ff9a2b;
    }
    .username {
        width: 100%;
        position: fixed;
        left: 50%;
        margin-left: -50%;
        margin-top: 1.1rem;
        text-align: center;
        font-size: 1.2rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 1.2rem;
        text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.6);
        transition: all 0.1s ease;
        transform: scale(1);
    }
    .username.name-egg {
        transform: scale(0.5);
    }
}
</style>
<script>
export default {
    name: "Avatar",
    props: {
        username: {
            type: String,
            default: ""
        },
        userId: {
            type: String,
            default() {
                return localStorage.userId
            }
        },
        textAvatar: "",
        avatarUrl: {
            type: String,
            default: ""
        },
        color: {
            type: String,
            default: ""
        },
        avatarBorder: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            avatar: false,
            egg: false,
            nameEgg: false
        }
    },
    mounted() {
        if (this.$route.name == "comment" && this.avatarUrl && this.avatarUrl !== "null" && !this.avatar) {
            this.avatar = true
        }
        this.lazyLoad()
    },
    updated() {
        if (this.$route.name == "comment" && this.avatarUrl && this.avatarUrl !== "null" && !this.avatar) {
            this.avatar = true
        }
        this.lazyLoad()
    },
    methods: {
        handleEgg() {
            if (window.isWebview) {
                this.$root.eventBus.$emit("checkVersion")
            }
            this.egg = true
            this.nameEgg = true
            setTimeout(() => {
                this.nameEgg = false
            }, 435)
            setTimeout(() => {
                this.egg = false
            }, 1100)
        },
        lazyLoad() {
            if (this.avatarUrl && this.avatarUrl !== "null" && !this.avatar) {
                var _this = this
                let originImg = document.querySelector(".lazyload")
                // 安全性检测
                const url = originImg.src && originImg.src !== "null" ? originImg.src : ""
                if (!url) return
                originImg.onload = function() {
                    _this.avatar = true
                }
            }
        }
    }
}
</script>
